<template>
  <div class="card block-card">
    <div class="front">
      <div class="strip-bottom"></div>
      <div v-show="false" class="skill">
        <p class="is-text-small">数据表示能力</p>
        <span v-for="i in 5">
          <v-color-icon name="star-fill" :fill="i >3 ? 'white' : '#ff8706'">
            {{ i }}</v-color-icon>
        </span>
      </div>
      <div v-show="false" class="catalog">
        <v-color-icon name="inbox"></v-color-icon>
        NumPy 库
      </div>
      <div class="collapse"
           @click="collapsed = !collapsed">
        <div>{{ collapsed ? '展开详细' : '收起' }}</div>
        <v-color-icon name="arrow-down-s" :rotate="collapsed ? 0 : 180"></v-color-icon>
      </div>
      <div class="card-content">
        <div class="title">{{ block.name }}</div>
        <div>{{ block.description }}</div>
        <div v-html="block.rendered_desc"
             v-show="!collapsed"
             class="content notebook-content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['block'],
  data () {
    return {
      collapsed: true
    }
  }
}
</script>

<style lang="stylus" scoped>
.card.block-card {
  overflow hidden
  font-size 14px
  border-radius 3px
  position relative
  min-height 150px
  box-shadow 3px 2px 30px 0 rgba(51, 51, 51, .1)

  &:before {
    content ''
    position absolute
    width 80%
    left 10%
    height 2px
    background $link
    bottom 0
    z-index 1
  }

  .collapse {
    position absolute
    bottom 0
    left 50%
    text-align center
    transform translateX(-50%)
    line-height 1
    opacity: 0;
    z-index: 2;
    cursor pointer
    font-size 12px
  }

  .notebook-content {
    padding 1rem 1.4rem
    box-shadow inset 0 0 2px 1px rgba(0, 0, 0, .1)
    margin 1rem -1.4rem
    background white
  }

  &:hover .collapse {
    opacity: 1;
  }

  .title {
    font-size 1.4rem
    font-weight bold
  }

  .skill {
    display inline-block
    border-radius 5px
    text-align center
    margin-top .75em
    position absolute
    right 1rem
    bottom 1rem
    line-height 1.3
    color #666666
  }

  .catalog {
    position absolute
    bottom 1.5rem
    left 1.25rem
    font-size 12px
    color #666666
    background linear-gradient(to bottom, white, $neBg)
    padding 0 5px
  }

  .strip-bottom {
    position: absolute
    right: 0
    height: 100%
    background-image: linear-gradient(to bottom, white, $neBg)
    width: 160px
    transform: skewX(-15deg) translateX(50px)
  }

  .card-content {
    z-index 1
    position relative
    padding 1rem 1.25rem 50px 1.25rem
  }
}
</style>
